const integerFormatter = new Intl.NumberFormat('en-US');

export const formatInteger = (value: number): string => integerFormatter.format(value);
